import { Link } from 'react-router';
import { ColorSchemeToggle, Container } from '../../Atoms';
import XVerWhiteLogo from './../../../assets/image/xver-white.svg';

export default function EntryHeader() {
    return (
        <header
            className="sticky top-0 left-0 w-full h-12.5 px-5 sm:h-18 xl:px-0"
            style={{
                zIndex: 512,
                backgroundColor: 'var(--color-background)',
                borderWidth: '0 0 0.5px 0',
                borderColor: 'var(--color-border)',
                color: 'var(--color-text)',
            }}
        >
            <Container className="h-full flex items-center justify-between">
                <div className="h-full flex items-center justify-start gap-8">
                    <Link
                        to="/"
                        className="hover:opacity-85 transition-opacity ease-in-out duration-150 inline-block items-center"
                    >
                        <img
                            src={XVerWhiteLogo}
                            alt="xver logo"
                            width="128"
                            height="auto"
                            className="w-22 h-auto cursor-pointer select-none sm:w-26"
                        />
                    </Link>
                </div>
                <ColorSchemeToggle />
            </Container>
        </header>
    );
}
